import {
    SIGN_IN_SUBMIT,
    LOAD_NRC_PRE_NUMBER,
    NRC_PRE_NUMBER,
    NRC_BODY1,
    NRC_BODY2,
    NRC_BODY3,
    NRC_NATIONALITY,
    NRC_NUMBER,
    BOOKING_REFERENCE,
    LOAD_SIGN_IN,
    BAD_REQUEST
} from '../actions/types'

const INITIAL_STATE = {
    signInData: {
        name: '',
        nrc: ''
    },
    nrcPreNumber: '',
    nrcBody1:'',
    nrcBody2:'',
    nrcBody3:'',
    nrcNatioanlity:'',
    nrc: '',
    booking_number: '',
    nrcData: {
        nrc_pre_num: [],
        nrc_body: [],
        national: []
    },
    userName: '',
    eligableUnit: 0,
    booked_unit: 0,
    bookings_detail: [],
    loading: false,
    bad_request: false,
    signInSuccess: false,
   
}

// nrcData : {
//     ...state.nrcData.nrc_pre_num, nrc_pre_num: action.payload.nrc_pre_num,
//     ...state.nrcData.nrc_body, nrc_body: action.payload.nrc_body
// }
export default (state = INITIAL_STATE, action ) => {

    // console.log('----- nrcdata -------')
    // console.log(action.payload)

    switch( action.type ){

        case SIGN_IN_SUBMIT:

            return {
                ...state, signInSuccess: true, 
                          loading: false,
                          useName: action.payload.name,
                          eligableUnit: action.payload.eligable_unit,
                          booked_unit: action.payload.booked_unit,
                          bookings_detail: action.payload.bookings_detail
            }

        case LOAD_NRC_PRE_NUMBER:
            return  {...state ,
                  nrcData : {
                        ...state.nrcData.nrc_pre_num, nrc_pre_num: action.payload.nrc_pre_num,
                        ...state.nrcData.nrc_body, nrc_body: action.payload.nrc_body,
                        ...state.nrcData.national, national: action.payload.national
                    }
                }

        case NRC_PRE_NUMBER:
            return { ...state, nrcPreNumber: action.payload}

        case NRC_BODY1:
            return { ...state, nrcBody1: action.payload}
        
        case NRC_BODY2:
            return { ...state, nrcBody2: action.payload}
        
        case NRC_BODY3:
            return { ...state, nrcBody3: action.payload}

        case NRC_NATIONALITY:
            return { ...state, nrcNatioanlity: action.payload}
        
        case NRC_NUMBER:
            return { ...state, nrc: action.payload}
        
        case BOOKING_REFERENCE:
            return { ...state, booking_number: action.payload}
        
        case LOAD_SIGN_IN:
                return { ...state, loading: action.payload}
        
        case BAD_REQUEST: 
                return { ...state, bad_request: action.payload, loading: false}
            
                
        default:
            return state
    }

}